/*
 * action types
 */

export const SET_PWD_SELECTED = "SET_PWD_SELECTED";
export const DELETE_PWD_SELECTED = "DELETE_PWD_SELECTED";
export const ADD_POC_SELECTION = "ADD_POC_SELECTION";
export const DELETE_POC_SELECTION = "DELETE_POC_SELECTION";

export const FETCH_FILER_CASE_DATA = "FETCH_FILER_CASE_DATA";
export const FETCH_FILER_CASE_DATA_SUCCESS = "FETCH_FILER_CASE_DATA_SUCCESS";
export const FETCH_FILER_CASE_DATA_FAILED = "FETCH_FILER_CASE_DATA_FAILED";

export let pwdSelected = (meta_case_number) => {
  return { type: SET_PWD_SELECTED, meta_case_number };
};

export let deletepwdSelected = () => {
  return { type: DELETE_PWD_SELECTED };
};

export let addPOCSelection = (selection) => {
  return { type: ADD_POC_SELECTION, selection };
};

export let fetchFilerCaseDataSuccess = (payload) => {
  return {
    type: FETCH_FILER_CASE_DATA_SUCCESS,
    payload,
  };
};

export let fetchFilerCaseDataFail = (payload) => {
  return {
    type: FETCH_FILER_CASE_DATA_FAILED,
    payload,
  };
};
